
import { ActionIdEnum } from "src/app/core/enums/list-layout/action-id-enum";
import { ButtonIdEnum } from "src/app/core/enums/list-layout/button-id-enum";
import { ButtonTypeEnum } from "src/app/core/enums/list-layout/button-type-enum";
import { ColumnTypeEnum } from "src/app/core/enums/list-layout/column-type-enum";
import { SecurityOperations } from "src/app/core/security/security-operations";
import { AuthMyfileService } from "src/app/core/services/auth.myfile.service";
import { GlobalComponent } from "src/app/global-component";

import { NgSelectListModel } from "src/app/core/models/ng-select-list.model";
import { SortByValuesModel } from "src/app/core/models/table/sort-by-values.model";
import { TableConfigurationModel } from "src/app/core/models/table/table-configuration.model";
import { TableContactFilter } from "../contact-list/configs/table-contact-filter-config-enum";
import { BoolEnum } from "src/app/core/enums/bool-enum";

export class ContactPickListTableConfig extends TableConfigurationModel {
    
     constructor() {
        super();
        this.canConfigBeSavedToServer = true;
        this.listTitle = "Contact Pick List";
        this.pageSizeFilter = [
            { pageSize: GlobalComponent.defaultPagingInfo.pageSize },
            { pageSize: 25 },
            { pageSize: 50 }
        ]
        this.columns = [
            {
                visible: 'true',
                order: 0,
                width: "15px",
                type: ColumnTypeEnum.CheckBox,
            },
            {

                dataFieldName: 'number',
                title: 'Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 1,
                width: "70px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'fullName',
                title: 'Name',
                sortable: new SortByValuesModel('firstName'),
                visible: 'true',
                order: 2,
                width: "200px",
                type: ColumnTypeEnum.PhotoModel,
            },

            {
                dataFieldName: 'companyName',
                title: 'Company Name',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 3,
                width: "150px",
                type: ColumnTypeEnum.Model
            },
            {
                dataFieldName: 'email',
                title: 'Email',
                visible: 'true',
                sortable: new SortByValuesModel,
                order: 4,
                width: "150px",
                type: ColumnTypeEnum.String
            },
            {
                dataFieldName: 'phoneNumber',
                title: 'Phone Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 5,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                dataFieldName: 'faxNumber',
                title: 'Fax Number',
                sortable: new SortByValuesModel,
                visible: 'true',
                order: 6,
                width: "125px",
                type: ColumnTypeEnum.String,
            },
            {
                title: 'Actions',
                visible: 'true',
                order: 7,
                width: "125px",
                type: ColumnTypeEnum.Action
            },
        ]
        this.filters = [
            {
                label: TableContactFilter.ContactStatusFilter,
                options: [  
                    new NgSelectListModel(undefined, $localize`:@@:Select Status`,$localize`:@@:Select Status`,undefined, true ),
                    new NgSelectListModel(BoolEnum.True, $localize`:@@Contact_Status_Enabled:Enabled`,$localize`:@@Contact_Status_Enabled:Enabled`, "bx bx-check-circle" ),
                    new NgSelectListModel(BoolEnum.False, $localize`:@@Contact_Status_Disabled:Disabled`,$localize`:@@Contact_Status_Disabled:Disabled`,"bx bx-error-alt"),
                ],
                selectedOption: undefined,
                inDropdown: true,
                inHeading: false,
                inButton: false,
            }
        ]
        this.searchbarFilter =
        {
            value: '',
            placeHolderText: "Search for contact number, name, company name, or email"
        }
        this.actions = [
            {   
                visible: SecurityOperations.account.accountRead,
                label: 'View',
                actionId: ActionIdEnum.View,
                icon: 'ri-eye-fill',
                inDropdown: false,
                inList: true
            },
            {
                visible: SecurityOperations.account.accountUpdate,
                label: 'Edit',
                actionId: ActionIdEnum.Edit,
                icon: 'ri-edit-line',
                inDropdown: true,
                inList: false
            },
            {
                visible: SecurityOperations.account.accountDelete,
                label: 'Delete',
                actionId: ActionIdEnum.Delete,
                icon: 'ri-delete-bin-fill',
                inDropdown: true,
                inList: false
            },
        ]
        this.buttons = [
            {
                visible: SecurityOperations.account.accountCreate,
                label: "Create New",
                iconIsAfterLabel: false,
                action: ButtonIdEnum.CreateNew,
                color: "btn-success",
                icon: "ri-add-fill",
                type: ButtonTypeEnum.Default
            },

            {
                visible: 'true',
                label: "Export",
                action: ButtonIdEnum.None,
                color: "btn-soft-info",
                iconIsAfterLabel: true,
                icon: "ri-more-2-fill",
                type: ButtonTypeEnum.Dropdown,
                actions: [
                  {
                        text: $localize`:@@Export_Excel:Export to Excel`,
                        value: `${ButtonIdEnum.ExportExcel}`,
                        color: 'btn-soft-primary',
                        visible: 'true'
                    },
                    {
                        text:  $localize`:@@Export_CSV:Export to CSV`,
                        value: `${ButtonIdEnum.ExportCSV}`,
                        color: 'btn-soft-primary',
                        visible: 'true'
                    },
                    {
                        text: $localize`:@@Export_Org:Export to Org.`,
                        value: `${ButtonIdEnum.ExportTenant}`,
                        color: 'btn-soft-primary',
                        visible: SecurityOperations.account.accountExport
                    }
                ]
            }
        ]
        this.doubleClickSelect =
        {
            action: ActionIdEnum.Select,
            enabled: true
        }
    }
}